<div class="login-qr"><img [src]="qrCode()" alt="QR Code" /></div>
